import React, { useState, useEffect } from 'react';
import SelectQuote from '../../../components/SelectQuote/SelectQuote';
import { filterSymbolNames, getDefaultQuote } from '../../../utils/QuoteUtils';
import TickerRow from './TickerRow';
import { getSymbols } from '../../../services/SymbolsService';
import { processError } from '../../../services/ServiceUtils';
import '../Dashboard.css';
import { getStoredValue, setStoredValue } from '../../../utils/StorageUtils';

/**
 * props:
 * - data
 */
function Ticker(props) {

    const [symbols, setSymbols] = useState([]);

    const [quote, setQuote] = useState(loadQuote());

    const [filterByPriceChange, setFilterByPriceChange] = useState(false);

    function loadQuote() {
        return getStoredValue('miniTickerQuote', getDefaultQuote());
    }

    function saveQuote(value) {
        setStoredValue('miniTickerQuote', value);
    }

    useEffect(() => {
        getSymbols(false)
            .then(symbols => setSymbols(filterSymbolNames(symbols.rows, quote)))
            .catch(err => processError(err))
    }, [quote])

    function onQuoteChange(event) {
        saveQuote(event.target.value);
        setQuote(event.target.value);
    }

    if (!props || !props.data) return (<React.Fragment></React.Fragment>);

    function mustShowRow(data) {
        // Esconde pares sem dado ao vivo ou com preço 0 (deslistados/inativos, ex: BTTUSDT, BCCUSDT).
        if (!data || !(parseFloat(data.close) > 0)) return false;
        return !filterByPriceChange || (data.percentChange > 10);
    }

    function onChangeFilter(event) {
        setFilterByPriceChange(!filterByPriceChange);
    }

    return (
        <div className="col-12 mb-4">
            <div className="card border-0 shadow">
                <div className="card-header">
                    <div className="row">
                        <div className="col">
                            <h2 className="fs-5 fw-bold mb-0">Mercado 24h</h2>
                        </div>
                        <div className="col offset-md-3">
                            <SelectQuote value={quote} onChange={onQuoteChange} />
                        </div>
                    </div>
                </div>
                <div className="table-responsive divScroll">
                    <table className="table align-items-center table-flush table-sm table-hover tableFixHead">
                        <thead className="thead-light">
                            <tr>
                                <th className="border-bottom" scope="col">SÍMBOLO</th>
                                <th className="border-bottom col-2 text-center" scope="col">FECHAMENTO</th>
                                <th className="border-bottom col-2 text-center" scope="col">ABERTURA</th>
                                <th className="border-bottom col-2 text-center" scope="col">MÁXIMA</th>
                                <th className="border-bottom col-2 text-center" scope="col">MÍNIMA</th>
                                <th className="border-bottom col-2 text-center" scope="col"><span className={'btn btn-primary btn-sm ' + (filterByPriceChange ? 'text-warning' : '')} role='button' title='Clique para filtrar variação > 10%' onClick={onChangeFilter}>VARIAÇÃO</span></th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                (filterByPriceChange ? symbols.sort((a,b) => props.data[a] && props.data[b] ? props.data[b].orderGap - props.data[a].orderGap : 0) : symbols ).map(item =>
                                    mustShowRow(props.data[item])
                                    ? (<TickerRow key={item} symbol={item} data={props.data[item]} />)
                                    : <React.Fragment></React.Fragment>
                                )
                            }
                        </tbody>
                    </table>
                </div>

            </div>
        </div>
    )
}

export default Ticker;